export default {
    unlock(code, axios) {
        return axios({
            url: `auth/unlock`,
            method: 'POST',
            data: {code: code}
        })
    },
    forgotPassword(email, axios) {
        return axios({
            url: `auth/forgot-password`,
            method: 'POST',
            data: {email: email}
        })
    },
    resetPassword({ email, token, password, password_confirmation}, axios) {
        return axios({
            url: `auth/reset-password`,
            method: 'POST',
            data: { email, token, password, password_confirmation }
        })
    }
}
